import React, {useEffect, useImperativeHandle} from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import SurveyItem from './SurveyItem';
import Container from 'react-bootstrap/Container';
import {PropertiesUtil} from '@aperza/util';
import {Constraint} from '@aperza/validator';
import {Button} from '@aperza/ui';
import {Message} from '@aperza/ui';
import FormFieldUtil from '../../util/FormFieldUtil';
import useSurveyFieldMap from './UseSurveyFieldMap';
import SurveyComment from "./SurveyComment";

const SurveyPage = React.forwardRef((props, ref) => {

  let {
    surveyPage = {},
    loading,
    showSubmitButton,
    enableComment,
    readOnly,
  } = props;
  console.log('SurveyPage ref', ref)

  let {
    items = [],
  } = surveyPage;

  let {
    fieldMap,
    initFieldMap,
    updateFieldValue,
    validateFieldMap,
  } = useSurveyFieldMap(items);

  useImperativeHandle(ref, () => ({
    validate: () => {
      console.log('SurveyPage validate')
      return validateFieldMap();
    }
  }));

  useEffect(() => {
    console.log('SurveyPage ref', ref)
    initFieldMap(items, enableComment);
  }, [items, enableComment]);

  const onSubmit = () => {
    let updatedFields = validateFieldMap();
    console.log('onSubmit updatedFields', updatedFields);
    if (!FormFieldUtil.hasError(updatedFields) && props.onSubmit) {
      console.log('onSubmit', fieldMap);
      props.onSubmit(updatedFields);
    }
  };

  return (
    <Container fluid="true" className="aw-form mb-5">
      {/*<h4 className="font-weight-bold text-primary">Survey Page: {surveyPage.plainId}</h4>*/}
      {items.map((item, index) => {
        let fieldName = `field_${item.plainId}`;
        return (
          <SurveyItem surveyItem={item}
                      key={index}
                      readOnly={readOnly}
                      updateFieldValue={updateFieldValue}
                      {...fieldMap[fieldName]} />
        )
      })}
      {enableComment &&
      <SurveyComment readOnly={readOnly}
                     updateFieldValue={updateFieldValue}
                     {...fieldMap['field_comment']}
      />}
      {showSubmitButton &&
      <div className={'mt-3'}>
        <Button size="xxl" loading={loading} type={Button.TYPE_PRIMARY} onClick={onSubmit}>
          <Message messageId={'completeButton'}/>
        </Button>
      </div>
      }
    </Container>
  )

});

SurveyPage.fragments = {
  surveyPage: gql`
      fragment SurveyPage_surveyPage on SurveyPage
      {
          id
          plainId
          title
          description
          displayOrder
          items {
              id
              plainId
              answerRequired
              ...SurveyItem_surveyItem
          }
      }
      ${SurveyItem.fragment.surveyItem}
  `
};

export default SurveyPage;
